import React, { Component } from 'react';

import * as d3 from 'd3';
import * as _ from 'lodash';
import geoJson from '../../assets/map/custom.geo.json';

class Map extends Component {

  constructor(props) {
    super(props);
    this.state = {
      zoomTransform: null,
    };
  }

  componentDidMount() {
    this.renderMap()
  }

  renderMap = () => {
    var width = document.getElementById('map').clientWidth;
    var height = 450;

    const data = this.props.data;
    const label = this.props.label;

    var scale = (width - 1) / 2 / Math.PI
    var active = d3.select(null);
    
    var projection = d3.geoMercator()
        .translate([width /2, height /1.5])
        .scale(scale);
    
    var zoom = d3.zoom()
      .scaleExtent([1, 8])
      .on("zoom", zoomed);
    

    var colorScale = d3.scaleLinear()
      .domain([
          _.min(data.map((rec) => {return rec.value;})),
          _.max(data.map((rec) => {return rec.value;}))
          ])
      .range(['#f4c9b0', '#EB4F1E']);
    // var scaleCircle = d3.scaleLinear()
    //   .domain([
    //       _.min(data.map((rec) => {return rec.value;})),
    //       _.max(data.map((rec) => {return rec.value;}))
    //       ])
    //   .range([ 5, 15]);

    var path = d3.geoPath()
        .projection(projection);

    var svg = d3.select(this.refs.map).append('svg')
        .attr('width', width)
        .attr('height', height)
        .on("click", stopped, true);

    var g = svg.append('g');
    
    svg.call(zoom)

    var tooltip = d3.select('#map')
      .append("div")
      .attr("class", "tooltip")
      .style("position", "absolute")
      .style("pointer-event", "none")
      .style("padding", "10px")
      .style("border-radius", "5px")
      .style("box-shadow", "2px 2px 38px #ECECEC")
      .style("background-color", "white")
      .style("opacity", 0);

      g.selectAll("path")
        .data(geoJson.features)
        .enter()
        .append('path')
        .attr('class', 'land')
        .attr('id', (d) => d.id)
        .attr('d', path )
        .attr('cursor', 'auto')
        .style('stroke-width', 0.5)
        .style('stroke', '#FFFFFF')
        .style('cursor','pointer')
        .on("click", clicked)
        .attr('fill', (d) => {
            const found = data.find(item => item.id  === d.id)
            if (found) {
                return colorScale(found.value)
            } else {
                return '#e5e5e5'
            }
        })
        .on("mouseover", function(d) {
          const found = data.find(item => item.id  === d.id)
          if(found) {
            tooltip.html( d.properties.name + "<br/>" + found.value + " " + label )
            tooltip.transition()
              .duration(200)
              .style("display" ,"block")
              .style("opacity", .9)
              .style("left", (d3.event.pageX + 30 ) + "px")
              .style("top", (d3.event.pageY  - 35) + "px");
            }
          })
        .on("mouseout", function(d) {
          const found = data.find(item => item.id  === d.id)
          if(found) {
            tooltip.transition()
              .duration(0)
              .style("display" ,"none")
              .style("opacity", 0)
              .style("left", (d3.event.pageX + 30 ) + "px")
              .style("top", (d3.event.pageY  - 35) + "px");
          }
        })

    // g.selectAll("circle")
    //   .data(data)
    //   .enter()
    //   .append("circle")
    //   .attr("cx", function(d){ return projection([d.long, d.lat])[0] })
    //   .attr("cy", function(d){ return projection([d.long, d.lat])[1] })
    //   .attr("r", function(d){ return scaleCircle(d.value)})
    //   .attr("class", "circle")
    //   .style("fill", "#EB4F1E")
    //   .attr("fill-opacity", .5)
    //   .style('cursor','pointer')
    //   .on("click", clicked)
    //   .on("mouseover", function(d) {
    //       tooltip.html(d.city + " - " + d.country + "<br/>" + d.value + " consultants")
    //       tooltip.transition()
    //         .duration(200)
    //         .style("display" ,"block")
    //         .style("opacity", .9)
    //         .style("left", (d3.event.pageX + 30 ) + "px")
    //         .style("top", (d3.event.pageY  - 35) + "px");
    //     })
    //   .on("mouseout", function(d) {
    //       tooltip.transition()
    //         .duration(0)
    //         .style("display" ,"none")
    //         .style("opacity", 0)
    //         .style("left", (d3.event.pageX + 30 ) + "px")
    //         .style("top", (d3.event.pageY  - 35) + "px");
    //   })
        
        
    
    function clicked(data) {
        if (active.node() === this) return reset();
          active.classed("active", false);
          active = d3.select(this).classed("active", true);

        let d;

        if(data.country) {
          d = geoJson.features.filter(item => item.id ===  data.id)[0]
        } else {
          d = data
        }
      
        var bounds = path.bounds(d),
            dx = bounds[1][0] - bounds[0][0],
            dy = bounds[1][1] - bounds[0][1],
            x = (bounds[0][0] + bounds[1][0]) / 2,
            y = (bounds[0][1] + bounds[1][1]) / 2,
            scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / width, dy / height))),
            translate = [width / 2 - scale * x, height / 2 - scale * y];

        svg.transition()
            .duration(750)
            .call( zoom.transform, d3.zoomIdentity.translate(translate[0],translate[1]).scale(scale) );
      }
      
      function reset() {
        active.classed("active", false);
        active = d3.select(null);
      
        svg.transition()
            .duration(750)
            .call( zoom.transform, d3.zoomIdentity );
      }
      
      function zoomed() {
        g.style("stroke-width", 1.5 / d3.event.transform.k + "px");
        g.attr("transform", d3.event.transform);
        // g.selectAll("circle")
        //   .attr("r", function(d){ return scaleCircle(d.value) / d3.event.transform.k })
      }

      function stopped() {
        if (d3.event.defaultPrevented) d3.event.stopPropagation();
      }
  }

  render() {
    return (
      <div style={{ marginTop:'10px' }} id="map" ref="map" >
      </div>
    );
  }
}

export default Map;
